import { RouteObject } from "react-router-dom";
import Landing from "./Landing";
import AssetDetail from "@features/ax/assetRegistry/assets/components/Details/DetailsLanding";

export interface systemAlertsRoutes extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: systemAlertsRoutes[];
}

export const systemAlertsRoutes: systemAlertsRoutes[] = [
  {
    path: "/ax/system-alerts",
    element: <Landing />,
  },
  {
    path: "/ax/system-alerts/assets/view/:id",
    element: <AssetDetail />,
  },
];
